/*
  info-sources.js

  A local plugin to place info sources
  in the right place at the right time.

  Author: Tim Bauwens
*/

import { escapeHTML } from "$json/lib/escape";
import { converter } from "$md-converter";

function getInfo(info) {
  return !info.isurl ? info.content : false;
}

function toggleInfosource(_e, force) {
  bb.Mode.toggle("hasInformationsource", force);
}

((doc, $) => {
  const container = doc.querySelector(".p-info-sources--content");
  const infoButton = doc.createElement("span");
  infoButton.className = "p-info-sources--toggleSpan";
  infoButton.innerHTML = `
    <button
      aria-label="toon meer informatie"
      class="p-info-sources--toggle">
        meer informatie
    </button>
  `;

  $(doc).on("bb:postHandleData", (_e, data) => {
    toggleInfosource(null, false);
    if (data && data.informationsources && data.informationsources.length) {
      container.querySelectorAll(".p-info-source--item").forEach(old => {
        container.removeChild(old);
      });
      const info = data.informationsources.map(getInfo);
      info.forEach(item => {
        let template = `
        <div class="p-info-source--item">${converter.makeHtml(
          escapeHTML(item),
          false
        )}</div>
      `;
        container.insertAdjacentHTML("afterbegin", template);
      });
      // Now place the button - always on 1st question.
      let currentButton = doc.querySelector(
        "#bb-q .bb-questionlabelgroup .p-info-sources--toggle"
      );
      if (currentButton) {
        currentButton.parentNode.removeChild(currentButton);
      }
      let pos =
        doc.querySelector("#bb-q .bb-questionlabelgroup") !== null
          ? doc.querySelector("#bb-q .bb-questionlabelgroup")
          : doc.querySelector("#bb-q");
      pos.prepend(infoButton);
      infoButton.addEventListener("click", toggleInfosource);
    }
  });

  // Handler
  doc
    .querySelector(".p-info-sources--toggle")
    .addEventListener("click", toggleInfosource);
})(document, jQuery);
